/*
 * @Author: Nora Galvin
 * @Date: 2020-08-19 15:54:55
 * @Last Modified by: Nora
 * @Last Modified time: 2020-10-03 12:20:40
 */
import type { TypeAnimation } from '../animations/type';

const delay = {
  key: 'delay',
  name: 'Delay',
  value: 0,
  min: 0,
  max: 2000,
  step: 100,
  'value-type': 'ms',
  type: 'slider',
};

const duration = {
  key: 'duration',
  name: 'Duration',
  value: 500,
  min: 50,
  max: 2050,
  step: 50,
  'value-type': 'ms',
  type: 'slider',
};

const loop = {
  key: 'loop',
  name: 'Loop',
  type: 'checkbox',
  options: [
    {
      key: 'iteration',
      name: 'Infinite',
      value: false,
    },
  ],
};

const screens = {
  key: 'screens',
  name: 'Trigger on',
  type: 'checkbox',
  options: [
    {
      key: 'lg',
      name: 'Desktop',
      value: true,
    },
    {
      key: 'md',
      name: 'Laptop',
      value: true,
    },
    {
      key: 'sm',
      name: 'Tablet',
      value: true,
    },
    {
      key: 'xs',
      name: 'Mobile',
      value: true,
    },
  ],
};

const defaultOptionsEntrance = [delay, duration, screens];

const defaultOptionsStandInPlace = [delay, duration, loop, screens];

export const animationsEntrance: Array<TypeAnimation> = [
  {
    key: 'back',
    name: 'Back',
    type: 'entrance',
    description: 'Object move in with smaller size and lower opactiy then back to normal',
    settings: [
      {
        key: 'direction',
        title: 'Direction',
        value: 'in-left',
        type: 'select',
        options: [
          {
            key: 'in-left',
            value: 'Left In',
          },
          {
            key: 'in-right',
            value: 'Right In',
          },
          {
            key: 'in-up',
            value: 'Top In',
          },
          {
            key: 'in-down',
            value: 'Bottom In',
          },
          {
            key: 'out-left',
            value: 'Left Out',
          },
          {
            key: 'out-right',
            value: 'Right Out',
          },
          {
            key: 'out-up',
            value: 'Top Out',
          },
          {
            key: 'out-down',
            value: 'Bottom Out',
          },
        ],
      },
    ],
    options: defaultOptionsEntrance,
  },
  {
    key: 'bounce',
    name: '(E) Bounce',
    type: 'entrance',
    description: 'Bounce Object appear and bounce to normal position',
    settings: [
      {
        key: 'direction',
        title: 'Direction',
        value: 'in-left',
        type: 'select',
        options: [
          {
            key: 'in-left',
            value: 'Left In',
          },
          {
            key: 'in-right',
            value: 'Right In',
          },
          {
            key: 'in-up',
            value: 'Top In',
          },
          {
            key: 'in-down',
            value: 'Bottom In',
          },
          {
            key: 'out-left',
            value: 'Left Out',
          },
          {
            key: 'out-right',
            value: 'Right Out',
          },
          {
            key: 'out-up',
            value: 'Top Out',
          },
          {
            key: 'out-down',
            value: 'Bottom Out',
          },
        ],
      },
    ],
    options: defaultOptionsEntrance,
  },
  {
    key: 'fade',
    name: 'Fade',
    type: 'entrance',
    description: 'Object stand in place and fade from 0% to 100% opacity',
    settings: [
      {
        key: 'direction',
        title: 'Direction',
        value: 'in-left',
        type: 'select',
        options: [
          {
            key: 'in-left',
            value: 'Left In',
          },
          {
            key: 'in-right',
            value: 'Right In',
          },
          {
            key: 'in-up',
            value: 'Top In',
          },
          {
            key: 'in-down',
            value: 'Bottom In',
          },
          {
            key: 'out-left',
            value: 'Left Out',
          },
          {
            key: 'out-right',
            value: 'Right Out',
          },
          {
            key: 'out-up',
            value: 'Top Out',
          },
          {
            key: 'out-down',
            value: 'Bottom Out',
          },
        ],
      },
    ],
    options: defaultOptionsEntrance,
  },
  {
    key: 'flip',
    name: 'Flip',
    type: 'entrance',
    description: 'Object flip from the center (like a flipboard)',
    settings: [
      {
        key: 'flip',
        title: 'Flip',
        value: 'in-x',
        type: 'select',
        options: [
          {
            key: 'none',
            value: 'None',
          },
          {
            key: 'in-x',
            value: 'Flip In X',
          },
          {
            key: 'in-y',
            value: 'Flip In Y',
          },
          {
            key: 'out-x',
            value: 'Flip Out X',
          },
          {
            key: 'out-y',
            value: 'Flip Out Y',
          },
        ],
      },
    ],
    options: defaultOptionsEntrance,
  },
  {
    key: 'jack-in-the-box',
    name: 'Jack In the box',
    type: 'entrance',
    description: 'Jack puppet effect',
    options: defaultOptionsEntrance,
  },
  {
    key: 'zoom',
    name: 'Zoom',
    type: 'entrance',
    description: 'Object get bigger/smaller with fade effect',
    settings: [
      {
        key: 'flip',
        title: 'Flip',
        value: 'in',
        type: 'select',
        options: [
          {
            key: 'in',
            value: 'Zoom In',
          },
          {
            key: 'in-down',
            value: 'Zoom In Down',
          },
          {
            key: 'in-left',
            value: 'Zoom In Left',
          },
          {
            key: 'in-right',
            value: 'Zoom In Right',
          },
          {
            key: 'in-up',
            value: 'Zoom In Up',
          },
          {
            key: 'out',
            value: 'Zoom Out',
          },
          {
            key: 'out-down',
            value: 'Zoom Out Down',
          },
          {
            key: 'out-left',
            value: 'Zoom Out Left',
          },
          {
            key: 'out-right',
            value: 'Zoom Out Right',
          },
          {
            key: 'out-up',
            value: 'Zoom Out Up',
          },
        ],
      },
    ],
    options: defaultOptionsEntrance,
  },
  {
    key: 'slide',
    name: 'Slide',
    type: 'entrance',
    description: 'Object slide in short distant',
    settings: [
      {
        key: 'direction',
        title: 'Direction',
        value: 'in-left',
        type: 'select',
        options: [
          {
            key: 'in-left',
            value: 'Left In',
          },
          {
            key: 'in-right',
            value: 'Right In',
          },
          {
            key: 'in-up',
            value: 'Top In',
          },
          {
            key: 'in-down',
            value: 'Bottom In',
          },
          {
            key: 'out-left',
            value: 'Left Out',
          },
          {
            key: 'out-right',
            value: 'Right Out',
          },
          {
            key: 'out-up',
            value: 'Top Out',
          },
          {
            key: 'out-down',
            value: 'Bottom Out',
          },
        ],
      },
    ],
    options: defaultOptionsEntrance,
  },
];

export const animationsStandInPlace: Array<TypeAnimation> = [
  {
    key: 'bounce_',
    name: '(S) Bounce',
    type: 'stand-in-place',
    description: 'Bounce twice',
    options: defaultOptionsStandInPlace,
  },
  {
    key: 'flash',
    name: 'Flash',
    type: 'stand-in-place',
    description: 'Object stand in place and flash twice',
    options: defaultOptionsStandInPlace,
  },
  {
    key: 'pulse',
    name: 'Pulse',
    type: 'stand-in-place',
    description: 'Object scale bigger and smaller',
    options: defaultOptionsStandInPlace,
  },
  {
    key: 'rubber-band',
    name: 'Rubber band',
    type: 'stand-in-place',
    description: 'Rubber band Object animate like rubber band',
    options: defaultOptionsStandInPlace,
  },
  {
    key: 'shake-x',
    name: 'Shake X',
    type: 'stand-in-place',
    description: 'Object shake in horizontal',
    options: defaultOptionsStandInPlace,
  },
  {
    key: 'shake-y',
    name: 'Shake Y',
    type: 'stand-in-place',
    description: 'Object shake in vertical',
    options: defaultOptionsStandInPlace,
  },
  {
    key: 'swing',
    name: 'Swing',
    type: 'stand-in-place',
    description: 'Object stand in place and light swing',
    options: defaultOptionsStandInPlace,
  },
  {
    key: 'Jello',
    name: 'Jello',
    type: 'stand-in-place',
    description: 'Jelly effect',
    options: defaultOptionsStandInPlace,
  },
  {
    key: 'Heartbeat',
    name: 'Heartbeat',
    type: 'stand-in-place',
    description: 'Zoom in twice',
    options: defaultOptionsStandInPlace,
  },
];

export const customAnimations: Array<TypeAnimation> = [
  {
    key: 'start-an-animation',
    name: 'Start An Animation',
    type: 'custom',
    options: [
      {
        key: 'screens',
        name: 'Trigger on',
        type: 'checkbox',
        options: [
          {
            key: 'lg',
            name: 'Desktop',
            value: true,
          },
          {
            key: 'md',
            name: 'Laptop',
            value: true,
          },
          {
            key: 'sm',
            name: 'Tablet',
            value: true,
          },
          {
            key: 'xs',
            name: 'Mobile',
            value: true,
          },
        ],
      },
    ],
  },
  // {
  //   key: "action-with-url",
  //   name: "Action With URL",
  //   type: "custom"
  // }
];

export const animations: Array<TypeAnimation> = [...animationsEntrance, ...animationsStandInPlace];
